import { useEffect } from 'react';

// Builder specific reset scroll position on changing layout
export default function useResetLayoutScroll({
  itemContainerRef,
  listPresentationConfig,
  columns,
  isMobile,
}) {
  useEffect(() => {
    if (itemContainerRef) {
      itemContainerRef.scrollTo(0, 0);
    }
  }, [itemContainerRef, listPresentationConfig?.layoutName, columns, isMobile]);
  return null;
}
